// src/pages/reportUsage/utils/storeUnidSurgeryLocalState.js

import { STORE_UNID_SURGERY_INFO } from 'src/pages/reportUsage/redux/action/types';

/**
 * Utility to store UNiD surgery local state in redux.
 * @param {Object} params - All required references and values.
 * @param {Object} params.unidSurgeryInfo
 * @param {Function} params.dispatch
 */
export const storeUnidSurgeryLocalStateUtil = ({ unidSurgeryInfo, dispatch }) => {
  if (
    unidSurgeryInfo?.unidProducts?.some((product) => product.isChecked) &&
    (
      unidSurgeryInfo?.whyAllRodsNotImplanted?.some((product) => product.isChecked) ||
      unidSurgeryInfo.unidProducts?.some((product) => product.implantedAsMainRod == 'Yes') ||
      unidSurgeryInfo.unidProducts?.some((product) => product.implantedAsMainRod == 'No') ||
      unidSurgeryInfo.unidProducts?.every(
        (product) =>
          product.productCFN !== 'None' &&
          product.whyNotImplantedAsMainRod?.some((data) => data.isChecked)
      ) ||
      unidSurgeryInfo.mPXR
    )
  ) {
    dispatch({
      type: STORE_UNID_SURGERY_INFO,
      payload: unidSurgeryInfo,
    });
  }
};
